import { Container, Navbar, Nav, NavDropdown, Row, Col, Button } from 'react-bootstrap';

export default function MyWelcome() {
    
  return (
    
      <Row id="welcome-section">
          <Col className="align-self-center">
            <h1 className="text-center">Welcome!</h1>
          </Col>
      </Row>
    
    );
  }